<re-alert *ngIf="alert" [type]="alert.type" (close)="alert = null">{{ alert.message }}</re-alert>

<h1>Transaction Log</h1>



<form class="mt-3" role="form" novalidate name="form" #form="ngForm" method="post">
  <div class="row mt-3">
    <div class="col-lg-3 col-4">
      <div class="form-group">
        <label for="dateRangeControl">Date Range</label>
        <!--<input type="text" name="aa" id="dateRangeControl" [(ngModel)]="date"/>-->
        <re-date-range name="dateRangeControl" id="dateRangeControl" (dateChanged)="dateChanged($event)" [(ngModel)]="date"></re-date-range>
      </div>
    </div>

    <div class="col-lg-3 col-4">
      <div class="form-group">
        <label for="dateRangeControl">Filter</label>
        <select2 [(ngModel)]="selectedStatus" [settings]="{width:'100%'}"
                 name="selectedStatusControl"
                 (onSelect)="selectedStatusChanged($event)"
                 [options]="statusOptions"></select2>

      </div>
    </div>
    <div class="col-lg-3 col-4" *ngIf="isLocationAdmin">
      <div class="form-group">
        <label for="dateRangeControl">Filter by Location</label>
        <select2 [(ngModel)]="selectedLocation" [settings]="{width:'100%'}" [required]="true"
                 name="selectedLocation"
                 (onSelect)="selectedLocationChanged($event)"
                 [options]="locationOptions"></select2>

      </div>
    </div>
 </div>
  <div class="row " *ngIf="data && queryParamSearch">
    <div class="col-12"><span class="font-italic">(Showing transactions for {{data[0]?.userFirstName}} {{data[0]?.userFirstName}}) </span> <a  class="ml-3" [routerLink]="['/transaction-log']">Show all transactions</a></div>
  </div>
  <div class="row mt-3">

    <div class="form-inline col-6">
      <div class="form-group ">
        <input type="text" style="width:300px" name="searchControl"  #searchControl [autofocus]="true" class="form-control" placeholder="Search by Name or Initiated By" [(ngModel)]="searchText" />
      </div>
      <div class=" form-group ">
        <button type="submit" class="btn btn-primary ml-2 " (click)="search()" [disabled]="!form.valid">Search</button>
      </div>

    </div>
    <div class="col-6  pull-right text-right justify-content-end">
      <span *ngIf="isLocationAdmin && selectedLocationName">
        <span class="font-weight-bold">Selected Location:</span>
        <span class="ml-2 mr-2">{{selectedLocationName}}</span>
      </span>      <a [routerLink]="[]" class="ml-3" (click)="expandAll()">Expand All</a>
      <span class="text-primary ml-2 mr-2">|</span>
      <a href="javascript:void(0)" (click)="collpseAll()">Collapse All</a>
    </div>
  </div>


</form>


<div class="mb-4">
  <table class="table table-striped table-bordered" style="width:100%;" id="errorList">
  </table>
</div>
